import Lock from "@/utils/images/Lock";
import s from "./modal.module.scss";

const Modal = ({ content, style }) => {
  const base = window?.general_settings;
  const logo = base?.logo;
  const alt = base?.brand_name;

  return (
    <>
      <div className={s["modal__overlay"]} />
      <section className={s["modal__wrapper"]}>
        <div className={s["modal__header"]}>
          <div className={s["modal__header-image"]}>
            <img src={logo} alt={alt} />
          </div>
          <div className={s["modal__security"]}>
            <Lock />
            <p className={s["modal__security-text"]}>Secure Form</p>
          </div>
        </div>
        <div className={s["modal__content"]} style={style}>
          {content}
        </div>
      </section>
    </>
  );
};

export default Modal;
